import { NgModule } from '@angular/core';
import { ngxZendeskWebwidgetModule, ngxZendeskWebwidgetConfig } from 'ngx-zendesk-webwidget';


export class ZendeskConfig extends ngxZendeskWebwidgetConfig {
  accountUrl = 'biodigital.zendesk.com';
  beforePageLoad(zE) {
    zE.setLocale('en');
    zE.hide();
  }
}

@NgModule({
  declarations: [],
  imports: [
    ngxZendeskWebwidgetModule.forRoot(ZendeskConfig)
  ]
})
export class ZendeskConfigModule { }
